import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getLineAnalytics } from '../../services'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetLineAnalyticsResponse,
	GetLineAnalyticsRequest,
} from '@/modules/dashboard/type'

export default function useQueryGetLineAnalytics(
	payload?: GetLineAnalyticsRequest,
	props?: UseBaseQueryOptions<GetLineAnalyticsResponse>,
) {
	return useQuery({
		queryKey: [DashboardKeys.LineAnalytics, payload],
		queryFn: () => getLineAnalytics(payload),
		...props,
	})
}
